const eventViewAccessoriesPDP = (params, category?: string) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: 'productDetail',
      eventCategory: `ecommerce aksesoris`,
      eventLabel: `aksesoris - ${category || 'not available'}`,
      ecommerce: {
        currencyCode: 'IDR',
        detail: {
          products: [params],
        },
      },
    });
  }
};

export default eventViewAccessoriesPDP;
